import { HttpLib } from './http-lib';
export let baseUrl = process.env.VUE_APP_BASE_URL;
import { CacheStrategy } from './cache-strategy';
import { concat, isEmpty } from 'ramda';
function assignBaseUrl() {
    if (/(localhost)|(192.168)/.test(location.origin)) {
        baseUrl = process.env.VUE_APP_BASE_URL;
    }
    else {
        baseUrl = `${location.origin}`;
        console.log(`Setting Base URL to ${baseUrl}`)
    }
}
assignBaseUrl();
export const createHttpGetOptions = ({
    cacheStrategy = CacheStrategy.REQUEST_FIRST,
    cancelToken = undefined,
    noJsonOutput = false,
    responseType = 'json',
    qsStringifyArrayFormat = undefined,
    onUploadProgress = undefined,
    withCredentials = true,
    subdomain = undefined,
} = {}) => {
    if (process.env == 'production') {
        cacheStrategy = CacheStrategy.REQUEST_FIRST;
    }
    if (qsStringifyArrayFormat === true) {
        qsStringifyArrayFormat = 'repeat';
    }
    return {
        cacheStrategy,
        cancelToken,
        noJsonOutput,
        responseType,
        qsStringifyArrayFormat,
        onUploadProgress,
        withCredentials,
        subdomain
    }
};

const post = async (url, data, options = createHttpGetOptions()) => {
    return HttpLib.post(`${baseUrl}` + url, querystring.stringify(data, { arrayFormat: 'brackets' }), {
        withCredentials: true,
        cancelToken: options.cancelToken
    })
        .then(res => {
            return res.data;
        })
        .catch(errorHandler);
};

const get = async (ul = '', params = {}, options = createHttpGetOptions()) => {
    let url = `${baseUrl}` + ul;

    const finalURL = `${url}${!isEmpty(params) ? `?${querystring.stringify(params)}` : ''}`;
    return HttpLib.get(finalURL, {
        withCredentials: true,
        cancelToken: options.cancelToken
    }).then(res => {
        return res.data;
    })
        .catch(errorHandler);
};

export const jsonToFormData = (obj) => {
    const formData = new FormData();
    for (let key in obj) {
        formData.append(key, obj[key]);
    }
    return formData;
}

export const postJSONasFormData = (url, jsonOBJ, options = createHttpGetOptions()) => {
    const formData = jsonToFormData(jsonOBJ);
    return HttpLib.post(`${baseUrl}` + url, formData, {
        withCredentials: true,
        cancelToken: options.cancelToken,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        responseType: options.responseType,
        onUploadProgress: options.onUploadProgress
    });
}
const errorHandler = e => {
    console.log(e.message);
    if (
        HttpLib.isCancel(e) ||
        isForbiddenError(e)
    ) {
        throw e;
    } else {

    }
};
export const isForbiddenError = (error) => error.message === 'Request failed with status code 403';
export const HttpClient = {
    get,
    post,
    postJSONasFormData,
    baseUrl
};